import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'monitor-blue',
  templateUrl: './monitor-blue.component.svg',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitorBlueComponent {}
